export default __webpack_public_path__ + "static/media/mariama.27e08840.jpeg";